(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7922],{

/***/ 87922:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content072": function() { return /* binding */ Content072; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_SocialSharing__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96352);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91929);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87900);
/* harmony import */ var shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32667);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87367);
/* harmony import */ var _Content072_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97644);
/* harmony import */ var _Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7__);








var Content072 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.headline) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var highlightedArticle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.highlightedArticle) !== null && ref1 !== void 0 ? ref1 : null;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)().t;
    var ref2 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_6__/* .useCollectedNewsRender */ .p$)({
        payload: payload,
        widgetNumber: "072"
    }), feed = ref2.feed, isCompleted = ref2.isCompleted, renderNext = ref2.renderNext, limit = ref2.limit, articleCategories = ref2.articleCategories;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().top),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Heading2 */ .XJ, {
                            className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                            children: title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .RenderIf */ .$b, {
                            viewMode: shared_contexts_ViewMode__WEBPACK_IMPORTED_MODULE_5__/* .VIEW_MODES.DESKTOP */ .nY.DESKTOP,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_SocialSharing__WEBPACK_IMPORTED_MODULE_2__/* .SocialSharing */ .e, {
                                title: t("socialTitle"),
                                inline: true,
                                appearance: "brand",
                                buttonClassName: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().button)
                            })
                        })
                    ]
                }),
                highlightedArticle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .HighlightedArticle */ .KW, {
                    item: highlightedArticle
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().blocks),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().feed),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .NewsItems */ .d2, {
                                    items: feed,
                                    className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().items),
                                    limit: limit
                                }),
                                !isCompleted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Action */ .aU, {
                                    onClick: renderNext,
                                    className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().more),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().loader),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["loader-wrapper"])),
                                            children: [
                                                t("lazyRendering"),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, {
                                                    className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default().icon),
                                                    name: "loader"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Content072_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["tags-list"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_4__/* .PopularTags */ .Dj, {
                                tags: articleCategories
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content072);


/***/ }),

/***/ 97644:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content072_wrapper__4Ml5s","more":"Content072_more__HqYTq","top":"Content072_top__QeACt","button":"Content072_button__hypZ1","blocks":"Content072_blocks__gzIds","feed":"Content072_feed__NTzsN","tags-list":"Content072_tags-list__FHV_k","loader":"Content072_loader__CH4VL","loader-wrapper":"Content072_loader-wrapper__W0Y5P","title":"Content072_title__dZoWU"};

/***/ })

}]);